import { Component, OnInit } from '@angular/core';
import { NotificationService } from '../../../services/notification.service';

@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.scss'],
})
export class UserDashboardComponent implements OnInit {
  notifications: { type: 'success' | 'error' | 'info'; message: string }[] = [];

  constructor(private notificationService: NotificationService) {}

  ngOnInit(): void {
    // Suscribirse al servicio para recibir nuevas notificaciones
    this.notificationService.notifications$.subscribe(notification => {
      this.addNotification(notification.type, notification.message);
    });
  }

  addNotification(type: 'success' | 'error' | 'info', message: string): void {
    this.notifications.push({ type, message });
    setTimeout(() => this.removeNotification(message), 5000); // Eliminar automáticamente
  }

  removeNotification(message: string): void {
    this.notifications = this.notifications.filter(
      notification => notification.message !== message
    );
  }
}
